import { mapParamsBySchema } from '../../../util';
import { apiRequest } from '../../../Services/Common/ApiRequest';
import Global from '../../../Services/Common/Global';
import { MET_BASIC_Schema } from './M_MET_BASIC_Schema';
import useSearchMutaion from '../../../Hooks/apis/useSearchMutaion';

const toDataResponse = (res) =>
  res != null && Array.isArray(res) ? { data: res } : res;

/** 안전보건 협의체 회의록 조회 GetMetBasicR2 (SP_SUB_BASIC_03_R2) */
export const useSearch2 = (successOptions) => {
  return useSearchMutaion(async (context) => {
    const params = mapParamsBySchema(
      MET_BASIC_Schema.mapper.search2,
      context
    );
    const res = await apiRequest(
      'post',
      Global.urls.Meeting.getMetBasicR2,
      params
    );
    return toDataResponse(res);
  }, successOptions);
};

/** 산업안전보건위원회 회의록 조회 GetMetBasicR3 (SP_SAC_BASIC_R6) */
export const useSearch3 = (successOptions) => {
  return useSearchMutaion(async (context) => {
    const params = mapParamsBySchema(
      MET_BASIC_Schema.mapper.search3,
      context
    );
    const res = await apiRequest(
      'post',
      Global.urls.Meeting.getMetBasicR3,
      params
    );
    return toDataResponse(res);
  }, successOptions);
};
